import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    IconButton,
    Grid,
    TextField
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { WelcomeBoardStaff } from '../../../common/interfaces';
import { FileSelector } from '../FileSelector';

interface StaffSettingsTabProps {
    staff: WelcomeBoardStaff[];
    onAddStaff: () => void;
    onRemoveStaff: (index: number) => void;
    onUpdateStaff: (index: number, field: keyof WelcomeBoardStaff, value: string) => void;
    onOpenFileManager: (staffIndex: number) => void;
    clientId: string;
}

export const StaffSettingsTab: React.FC<StaffSettingsTabProps> = ({
    staff,
    onAddStaff,
    onRemoveStaff,
    onUpdateStaff,
    onOpenFileManager,
    clientId
}) => {
    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">
                        Staff Members
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={onAddStaff}
                    >
                        Add Staff Member
                    </Button>
                </Box>

                {staff.map((member, index) => (
                    <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="subtitle1">
                                Staff Member {index + 1}
                            </Typography>
                            <IconButton
                                color="error"
                                onClick={() => onRemoveStaff(index)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Staff ID"
                                    value={member.staffId || ''}
                                    onChange={(e) => onUpdateStaff(index, 'staffId', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Staff Name"
                                    value={member.staffName || ''}
                                    onChange={(e) => onUpdateStaff(index, 'staffName', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FileSelector
                                    filePath={member.portraitImage}
                                    onFileChange={(filePath) => onUpdateStaff(index, 'portraitImage', filePath || '')}
                                    onBrowseClick={() => onOpenFileManager(index)}
                                    clientId={clientId}
                                    label="Portrait Image"
                                    fileType="image"
                                />
                            </Grid>
                        </Grid>
                    </Box>
                ))}

                {staff.length === 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                        No staff members added yet. Click "Add Staff Member" to get started.
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};
